import * as React from 'react';
import { withStyles, Theme, createStyles, WithStyles, Tabs, Tab, Grid, FormControl, InputLabel, Button, CircularProgress } from '@material-ui/core';
import { withUser, WithUser } from '../HOC/User';
import strings from 'src/strings';
import KDInput from '../Input/Input';
import { UsersAPI, errorToString } from 'src/api';
import KDGlobal from '../Global';
import { withToast, WithToast } from '../HOC/Toast';
import classNames from 'classnames';

export interface AccountInfoProps extends WithStyles<typeof styles>, WithUser<true>, WithToast {
    className?: string;
}
interface AccountInfoState {
    errors: {
        name?: boolean,
        email?: boolean,
        agency?: boolean
    },
    name: string;
    email: string;
    agency: string;
    loading: boolean
}
class AccountInfo extends React.Component<AccountInfoProps, AccountInfoState> {

    constructor(props: AccountInfoProps) {
        super(props);
        this.state = {
            errors: {

            },
            name: props.user.full_name,
            email: props.user.email!,
            agency: props.user.account.name || '',
            loading: false
        }
    }

    handleSubmit() {
        if (this.state.name.trim() == '') {
            this.props.showToast('error', strings.error_provideName)
            this.setState({ errors: { name: true } })
            return;
        } else if (this.state.agency.trim() == '') {
            this.props.showToast('error', strings.error_provideAgency)
            this.setState({ errors: { agency: true } })
            return;
        } else {
            this.setState({ errors: { agency: false, name: false }, loading: true })
        }
        UsersAPI.updateMe(this.state.name, { name: this.state.agency }).then((user) => {
            this.setState({ loading: false })
            this.props.showToast('success', strings.accountUpdated)
            KDGlobal.instance.setUser(user);
        }).catch(err => {
            this.setState({ loading: false })
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
        })
    }

    public render() {
        return <div className={classNames(this.props.classes.container, this.props.className || '')}>
            <FormControl fullWidth>
                <InputLabel htmlFor="agency">{strings.agency}</InputLabel>
                <KDInput error={this.state.errors.agency} id="agency" name="agency"
                    onEnterKey={this.handleSubmit.bind(this)}
                    autoComplete="agency" value={this.state.agency}
                    onChange={(e) => this.setState({ agency: e.target.value })} />
            </FormControl>
            <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="name">{strings.fullName}</InputLabel>
                <KDInput error={this.state.errors.name} id="name" name="name"
                    onEnterKey={this.handleSubmit.bind(this)}
                    autoComplete="name" value={this.state.name}
                    onChange={(e) => this.setState({ name: e.target.value })} />
            </FormControl>
            <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="email">{strings.emailAddress}</InputLabel>
                <KDInput error={this.state.errors.email} id="email" name="email" readOnly
                    onEnterKey={this.handleSubmit.bind(this)}
                    autoComplete="email" value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })} />
            </FormControl>
            <div className={this.props.classes.buttons}>
                <Button variant='outlined' color='secondary' onClick={this.handleSubmit.bind(this)}>
                    {this.state.loading ? <CircularProgress size={24} color='inherit' /> : strings.done}
                </Button>
            </div>
        </div>
    }
}
const styles = (theme: Theme) => createStyles({
    container: {
    },
    buttons: {
        paddingTop: 20,
        display: 'flex',
        justifyContent: 'flex-end',
    },
})
export default withToast(withUser(withStyles(styles)(AccountInfo), true))


// WEBPACK FOOTER //
// ./src/components/Settings/AccountInfo.tsx